function getNearestBusyIndicator(component) {
    if (component.$children) {
        var indicator = _.find(component.$children, c => c.$options && c.$options._componentTag == "busy-indicator");

        if (!indicator) {
            
            var amfForm = _.find(component.$children, c => c.$options && c.$options._componentTag == "amf-form");
            if (amfForm) {
                indicator = _.find(amfForm.$children, c => c.$options && c.$options._componentTag == "busy-indicator");
            }
        }

        if (indicator) return indicator;
    }

    if (component.$parent) return getNearestBusyIndicator(component.$parent);
}

const BusyIndicatorPlugin = {
    install(Vue) {
      Vue.mixin({
        data() {
            return { busy: false }
        },
        watch: {
            busy() {
                var indicator = getNearestBusyIndicator(this);
                if (indicator) indicator.busy = this.busy;
            }
        }
      });
    }
  };

  export default BusyIndicatorPlugin;



// WEBPACK FOOTER //
// ./src/framework/utils/busy-indicator-plugin.js